import React, { useEffect, useRef } from 'react';
import { SwipeModal } from '@hqo/react-components-library/dist/molecules/modals/swipe-modal';
import { useIntl } from 'react-intl';
import { DEFAULT_MODAL_BOTTOM_MARGIN } from 'shared/consts';
import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';
import { DesktopModalWrapper } from './desktop-modal-wrapper';
import { MobileModalContent } from './mobile-modal-content';
import { DesktopModalContent } from './desktop-modal-content';
import { useModalNavigation } from '../use-modal-navigation.hook';
import { useMiniappSdk } from 'components/miniapp-sdk-provider/miniapp-sdk.hook';
import { HEADER_BUTTON_MODE } from '@hqo/hqo-miniapp-client-sdk';

export const ModalContainer = () => {
  const intl = useIntl();
  const isMobileDevice = useIsSmallViewportWidth();
  const { handleCloseModal } = useModalNavigation();
  const client = useMiniappSdk();
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && !ref.current.style.marginBottom) {
      ref.current.style.marginBottom = DEFAULT_MODAL_BOTTOM_MARGIN;
    }
  }, []);

  useEffect(() => {
    if (isMobileDevice) {
      client.header.setHeader('', HEADER_BUTTON_MODE.HISTORY);
      client.header.showHeader();
    }
  }, [isMobileDevice, client]);

  return isMobileDevice ? (
    <SwipeModal
      title={intl.formatMessage({ id: 'terms_and_conditions' })}
      reverseAnimation={false}
      content={<MobileModalContent />}
      onClose={handleCloseModal}
      withLeftExitButton
      scrollContainerRef={ref}
    />
  ) : (
    <DesktopModalWrapper onClose={handleCloseModal} content={<DesktopModalContent />} />
  );
};
